"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebViewProviderResponseEnums = exports.WebViewProviderRequestEnums = exports.WebviewPlatforms = exports.AuthProviderType = void 0;
var AuthProviderType;
(function (AuthProviderType) {
    AuthProviderType["WALLET_CONNECT"] = "wallet_connect";
    AuthProviderType["WEBWALLET"] = "webwallet";
    AuthProviderType["EXTENSION"] = "extension";
    AuthProviderType["LEDGER"] = "ledger";
    AuthProviderType["PEM"] = "pem";
    AuthProviderType["WEBVIEW"] = "webview";
    AuthProviderType["NONE"] = "none";
})(AuthProviderType = exports.AuthProviderType || (exports.AuthProviderType = {}));
var WebviewPlatforms;
(function (WebviewPlatforms) {
    WebviewPlatforms["ios"] = "ios";
    WebviewPlatforms["reactNative"] = "reactNative";
    WebviewPlatforms["web"] = "web";
})(WebviewPlatforms = exports.WebviewPlatforms || (exports.WebviewPlatforms = {}));
var WebViewProviderRequestEnums;
(function (WebViewProviderRequestEnums) {
    WebViewProviderRequestEnums["signTransactionsRequest"] = "SIGN_TRANSACTIONS_REQUEST";
    WebViewProviderRequestEnums["signMessageRequest"] = "SIGN_MESSAGE_REQUEST";
    WebViewProviderRequestEnums["loginRequest"] = "LOGIN_REQUEST";
    WebViewProviderRequestEnums["logoutRequest"] = "LOGOUT_REQUEST";
    WebViewProviderRequestEnums["reloginRequest"] = "RELOGIN_REQUEST";
})(WebViewProviderRequestEnums = exports.WebViewProviderRequestEnums || (exports.WebViewProviderRequestEnums = {}));
var WebViewProviderResponseEnums;
(function (WebViewProviderResponseEnums) {
    WebViewProviderResponseEnums["signTransactionsResponse"] = "SIGN_TRANSACTIONS_RESPONSE";
    WebViewProviderResponseEnums["signMessageResponse"] = "SIGN_MESSAGE_RESPONSE";
    WebViewProviderResponseEnums["loginResponse"] = "LOGIN_RESPONSE";
    WebViewProviderResponseEnums["reloginResponse"] = "RELOGIN_RESPONSE";
})(WebViewProviderResponseEnums = exports.WebViewProviderResponseEnums || (exports.WebViewProviderResponseEnums = {}));
